import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  ReloadOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { UserRolesTableRow } from '@app/models/user_roles/UserRolesResponse';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseTable } from '@app/components/common/BaseTable/BaseTable';
import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { useMounted } from '@app/hooks/useMounted';
import { Space, Tooltip, Button, Popconfirm, Input } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Pagination } from '@app/api/table.api';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';

const initialPagination: Pagination = {
  current: 1,
  pageSize: 5,
};

export const ProductVarietiesTable: React.FC = () => {
  const [tableData, setTableData] = useState<{ data: UserRolesTableRow[]; pagination: Pagination; loading: boolean }>({
    data: [],
    pagination: initialPagination,
    loading: false,
  });

  const { t } = useTranslation();
  const { isMounted } = useMounted();
  const navigate = useNavigate();
  const [fieldsChanged, setFieldsChanged] = useState(false);
  const [form] = BaseButtonsForm.useForm();

  //   const fetch = useCallback(
  //     (pagination: Pagination) => {
  //       setTableData((tableData) => ({ ...tableData, loading: true }));
  //       getUserRolesTableData({ ...pagination, search: form.getFieldValue('search') })
  //         .then((res) => {
  //           if (isMounted.current) {
  //             setTableData({
  //               data: res.data,
  //               pagination: {
  //                 current: res.pagination.current,
  //                 pageSize: res.pagination.pageSize,
  //                 total: res.pagination.total,
  //               },
  //               loading: false,
  //             });
  //           }
  //         })
  //         .catch((error: any) => {
  //           notificationController.error({
  //             message: error.message,
  //           });
  //         });
  //     },
  //     [isMounted],
  //   );

  //   useEffect(() => {
  //     fetch(initialPagination);
  //   }, [fetch]);

  //   const handleTableChange = (pagination: TablePaginationConfig) => {
  //     fetch({
  //       current: pagination.current || 1,
  //       pageSize: pagination.pageSize || 5,
  //     });
  //   };

  //   const handleViewRow = (id: number) => {
  //     navigate(`/view-role/${id}`);
  //   };

  //   const handleEditRow = (id: number) => {
  //     navigate(`/edit-role/${id}`);
  //   };

  //   const handleDeleteRow = (id: number) => {
  //     console.log(`Deleting row with id ${id}`);
  //   };

  //   const showTotal = (total: number, range: [number, number]): React.ReactNode => {
  //     return (
  //       <span
  //         style={{ fontSize: '14px', marginRight: '20px', color: '#adadad' }}
  //       >{`Showing ${range[0]} - ${range[1]} of ${total} Roles`}</span>
  //     );
  //   };

  const handlebtnClick = () => {
    navigate('/add-product-variety');
  };

  const columns: ColumnsType<UserRolesTableRow> = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      width: '30%',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Product Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Actions',
      key: 'actions',
      width: '30%',
      render: (_, record) => {
        return (
          <Space>
            <Tooltip title="View">
              <Button
                type="text"
                //onClick={() => handleViewRow(record.id)}
                icon={<EyeOutlined />}
                style={{ color: '#1890ff' }}
              />
            </Tooltip>

            <Tooltip title="Edit">
              <Button
                type="text"
                // onClick={() => handleEditRow(record.id)}
                icon={<EditOutlined />}
                style={{ color: '#52c41a' }}
              />
            </Tooltip>

            <Tooltip title="Delete">
              <Popconfirm
                title="Are you sure to delete this role?"
                // onConfirm={() => handleDeleteRow(record.id)}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              >
                <Button type="text" danger icon={<DeleteOutlined />} style={{ color: 'red' }} />
              </Popconfirm>
            </Tooltip>
          </Space>
        );
      },
    },
  ];
  return (
    <BaseCard
      id="basic-table"
      title="Product Varieties"
      padding="1.25rem"
      extra={
        <BaseButtonsForm
          form={form}
          layout="inline"
          isFieldsChanged={fieldsChanged}
          setFieldsChanged={setFieldsChanged}
        >
          <BaseButtonsForm.Item name={'search'}>
            <Input
              size="middle"
              suffix={
                <Button
                  icon={<SearchOutlined />}
                  size="middle"
                  type="text"
                  //   onClick={() => {
                  //     fetch(initialPagination);
                  //   }}
                />
              }
              placeholder={'Search Product Varieties'}
            />
          </BaseButtonsForm.Item>
          <Button
            type="ghost"
            size="middle"
            icon={<ReloadOutlined />}
            // onClick={() => {
            //   form.resetFields(['search']);
            //   fetch(initialPagination);
            // }}
          />
        </BaseButtonsForm>
      }
    >
      <Space style={{ marginBottom: '16px', justifyContent: 'space-between', width: '100%' }}>
        <BaseButton icon={<PlusOutlined />} type="primary" onClick={handlebtnClick}>
          {t('Add Product Variety')}
        </BaseButton>
      </Space>
      <BaseTable
        columns={columns}
        dataSource={tableData.data}
        pagination={{
          current: tableData.pagination.current,
          pageSize: tableData.pagination.pageSize,
          total: tableData.pagination.total,
          // showTotal,
        }}
        loading={tableData.loading}
        //onChange={handleTableChange}
        scroll={{ x: true, scrollToFirstRowOnChange: true }}
      />
    </BaseCard>
  );
};
